module.exports = __webpack_public_path__ + "images/moodle.4d875390.webp";